export const firstLetters = (text?: string) => {
  if (!text) return "?";
  const firstLettersText = text
    .split(" ")
    .map((item) => item[0].toUpperCase())
    .join("");
  return firstLettersText;
};
